var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert-view"},[_c('v-alert',{attrs:{"border":"top","color":_vm.color,"dark":"","dismissible":""}},[_vm._v(" "+_vm._s(_vm.message)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }